import bTable from './bTable/BTable'
import bUpload from './bUpload/BUpload'
import bPage from './bPage/BPage'

const beefinx = {
  install: (Vue) => {
    Vue.component('b-table', bTable)
    Vue.component('b-upload', bUpload)
    Vue.component('b-page', bPage)
  }
}

export default beefinx
